import io from "socket.io-client";
import {API_URL} from "../config/custom";

let socket;
export const socketvar = {
  //  socket:io('http://localhost:3100')
 // socket:io('https://api.coachmentor.io')
 socket:io(API_URL)
 }
// module.exports = socketvar;